var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showNoticePopup && _setup.hasCampaignLayerPopup)?_c(_setup.NoticePopup,{attrs:{"close-popup-fn":_setup.closeEventPopup,"open-popup-fn":_setup.openEventPopup}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }